var _defs, _path, _path2, _path3, _animateTransform;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNavigationXIconAnimate = function SvgNavigationXIconAnimate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "navigation_x_icon_animate_svg__Layer_1",
    viewBox: "0 0 24 24"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".navigation_x_icon_animate_svg__st0{fill:#141414}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 16h18v2H3z",
    className: "navigation_x_icon_animate_svg__st0"
  }, /*#__PURE__*/React.createElement("animate", {
    fill: "freeze",
    attributeName: "y",
    begin: "0s",
    calcMode: "spline",
    dur: "0.4s",
    from: 16,
    keySplines: "0.2 0 0.65 1",
    keyTimes: "0;1",
    to: 11
  }), /*#__PURE__*/React.createElement("animateTransform", {
    fill: "freeze",
    attributeName: "transform",
    begin: "0.15s",
    calcMode: "spline",
    dur: 0.4,
    from: "0 12 12",
    keySplines: "0.2 0 0.65 1",
    keyTimes: "0;1",
    to: "-45 12 12",
    type: "rotate"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 11h18v2H3z",
    className: "navigation_x_icon_animate_svg__st0"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    fill: "freeze",
    attributeName: "transform",
    begin: "0.15s",
    calcMode: "spline",
    dur: 0.4,
    from: "0 12 12",
    keySplines: "0.2 0 0.65 1",
    keyTimes: "0;1",
    to: "45 12 12",
    type: "rotate"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3 6h18v2H3z",
    className: "navigation_x_icon_animate_svg__st0"
  }, /*#__PURE__*/React.createElement("animate", {
    fill: "freeze",
    attributeName: "y",
    begin: "0s",
    calcMode: "spline",
    dur: 0.4,
    from: 6,
    keySplines: "0.2 0 0.65 1",
    keyTimes: "0;1",
    to: 11
  }), /*#__PURE__*/React.createElement("animateTransform", {
    fill: "freeze",
    attributeName: "transform",
    begin: "0.15s",
    calcMode: "spline",
    dur: 0.4,
    from: "0 12 12",
    keySplines: "0.2 0 0.65 1",
    keyTimes: "0;1",
    to: "45 12 12",
    type: "rotate"
  }))), _animateTransform || (_animateTransform = /*#__PURE__*/React.createElement("animateTransform", {
    fill: "freeze",
    attributeName: "transform",
    begin: "0s",
    calcMode: "spline",
    dur: 0.4,
    from: 0.92,
    keySplines: "0.2 0 0.65 1",
    keyTimes: "0;1",
    to: 0.85,
    type: "scale"
  })));
};
export { SvgNavigationXIconAnimate as ReactComponent };
export default "data:image/svg+xml;base64,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";